import { ApolloError } from '@apollo/client';
import {
  Box,
  Button,
  ButtonAppearance,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalSize,
  Text,
} from '@bechtel/gds';
import { AssignWeldForemanError } from '@bechtel/types';
import { t, Trans } from '@lingui/macro';
import { FC } from 'react';

interface AssignWeldForemanErrorProps {
  assignWeldForemanError: AssignWeldForemanError | ApolloError;
  close: () => void;
}

const getErrorMessage = (error: AssignWeldForemanErrorProps['assignWeldForemanError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case AssignWeldForemanError.INVALID_WORKPACKAGE_ID:
      return <Trans>This workpackage is not valid for weld foreman assignment.</Trans>;
    case AssignWeldForemanError.INVALID_FOREMAN_ID:
      return <Trans>This selected user is not valid foreman.</Trans>;
    case AssignWeldForemanError.INVALID_COMMODITY_ID:
      return <Trans>This commodity id is not valid for weld foreman assignment.</Trans>;
    default:
      return <Trans>An error has occured. Please close button and try again.</Trans>;
  }
};

export const AssignWeldError: FC<AssignWeldForemanErrorProps> = ({ assignWeldForemanError, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="assign-weld-error">
      <ModalHeader title={t`Weld Foreman Error`}></ModalHeader>
      <ModalBody>
        <Box px={{ sm: '500' }} py={{ sm: '700' }}>
          <Text size="600">{getErrorMessage(assignWeldForemanError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
